import { render, staticRenderFns } from "./SocialUserAlterarUsuario.vue?vue&type=template&id=1ad3220f&scoped=true"
import script from "./SocialUserAlterarUsuario.vue?vue&type=script&lang=js"
export * from "./SocialUserAlterarUsuario.vue?vue&type=script&lang=js"
import style0 from "./SocialUserAlterarUsuario.vue?vue&type=style&index=0&id=1ad3220f&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad3220f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/thales/Recuperi/recuperi/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ad3220f')) {
      api.createRecord('1ad3220f', component.options)
    } else {
      api.reload('1ad3220f', component.options)
    }
    module.hot.accept("./SocialUserAlterarUsuario.vue?vue&type=template&id=1ad3220f&scoped=true", function () {
      api.rerender('1ad3220f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SocialUserAlterarUsuario.vue"
export default component.exports